var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"d-flex justify-center align-center py-16 my-auto",attrs:{"width":"100%","color":"transparent"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }